import { compose } from "recompose";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getApplicant } from "../Redux/Actions/ApplicationAction";

export default function withBranchHOC(Component) {
  class HOC extends Component {
    constructor(props) {
      super(props);
    }
  }

  HOC.propTypes = {};

  const mapStateToProps = (state) => ({
    finInfo: state.MarketplaceReducer.finInfo,
  });

  const mapDispatchToProps = (dispatch) => {
    return {
      doGetApplicant: (payLoad, callback) =>
        dispatch(getApplicant(payLoad, callback)),
    };
  };

  return compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(HOC);
}
